/**
 * Initiate DSP / WDSSO staff SSO login. Establishes the AM session, resolves the
 * username, fetches the staff profile, and persists the identity. dspAuthenticate()
 * creates the session; skipping it leaves the browser without an AM session.
 */

import { dspAuthenticate, getSessionInfo, getUserInfo } from './api';
import { getDspPair } from './credentials';
import { saveSsoSession } from './session';

/** Run the full SSO login sequence. */
export const initiateSsoLogin = async () => {
  // 1. Establish the AM SSO session via WDSSO. The encrypted client pair and its dspk
  //    come from the admin portal over the internal gateway and are decrypted here.
  const pair = await getDspPair();
  if (!pair.ok) {
    return { ok: false, error: 'Unable to load the SSO client configuration. Please try again later.' };
  }

  await dspAuthenticate(pair.dsps, pair.dspi);

  // 2. Resolve the authenticated username (validates the AM SSO session).
  const session = await getSessionInfo();
  if (!session.ok || !session.username) {
    return {
      ok: false,
      error:
        session.status === 401 || session.status === 403
          ? 'No active SSO session. Please sign in via SSO and try again.'
          : 'Please log in to the system with your Email.',
    };
  }

  // 3. Fetch the staff user profile.
  const profileResponse = await getUserInfo(session.username);
  if (!profileResponse.ok) {
    return { ok: false, error: 'Unable to load the SSO user profile. Please try again later.' };
  }

  // 4. Persist the SSO session.
  const identity = saveSsoSession({
    username: session.username,
    profile: profileResponse.data,
  });

  return { ok: true, user: identity };
};

export default initiateSsoLogin;
